<template>
  <div
    v-if="file.length && fileProcessing !== null"
    :class="fileProcessing.class"
    class="latest-file-card animated fadeIn"
  >
    <span class="latest-file-card__status"><i /></span>
    <div class="latest-file-card__info">
      <div class="latest-file-card__info-file">{{ fileText }}</div>
      <div v-if="file[0].updated_at" class="latest-file-card__info-date">
        Updated {{ file[0].updated_at | fileDate }}
      </div>
      <div class="latest-file-card__info-status">
        {{ fileProcessing.text
        }}<span v-if="file[0].error_count">({{ file[0].error_count }})</span>
      </div>
    </div>
  </div>
</template>
<script>
import consts from "../../_consts";
import moment from "moment";
export default {
  name: "latest-file-card-item",
  props: {
    file: {
      default: null
    },
    fileText: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      consts: consts
    };
  },
  filters: {
    fileDate(date) {
      return moment(date).format("MM/DD/YYYY");
    }
  },
  computed: {
    fileProcessing() {
      if (!this.file.length) return null;
      for (let key in consts.fileProcessing) {
        if (consts.fileProcessing[key].code === this.file[0].status) {
          return consts.fileProcessing[key];
        }
      }
      return null;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/LatestFileCardItem.vue